import React, { ReactElement, useEffect, useState } from 'react';
import { Immutable } from '@wds/utils';
import { List } from '@wds/list';

export const useDocument = (): Document | null => {
  const [myDocument, setMyDocument] = useState<Document | null>(null);

  useEffect(() => {
    setMyDocument(document);
  }, []);

  return myDocument;
};

export type SubMenuItemProps = Immutable<{
  title?: string;
  name?: string;
  path?: string;
  url?: string;
  openInNewWindow?: boolean;
  show?: boolean;
  metrics?: String;
}>;

export const SubMenuItem = ({
  title = '',
  name = '',
  path = '',
  url = '',
  openInNewWindow = false,
  show = true,
  metrics = '',
}: SubMenuItemProps): ReactElement | null => {
  const itemTitle = name || title;
  const itemURL = path || url;
  const doc = useDocument();

  if (!itemTitle || !itemURL || !show) return null;

  const currentPath = doc?.location.pathname ?? '';
  const isActive = path.startsWith(currentPath);

  return (
    <List.Item
      key={itemTitle}
      isNavigable
      navigationTarget={itemURL}
      data-sm-metrics={metrics}
      {...(openInNewWindow === true && {
        target: '_blank',
        rel: 'noopener noreferrer',
      })}
      color={isActive ? 'primary' : undefined}
      marked={isActive}
    >
      {itemTitle}
    </List.Item>
  );
};

export default SubMenuItem;
